import { render, staticRenderFns } from "./ConfigTabApprovalProcess.vue?vue&type=template&id=6aeb8702"
import script from "./ConfigTabApprovalProcess.vue?vue&type=script&lang=js"
export * from "./ConfigTabApprovalProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports